const AnjuAllReleases2020Static = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/idc-ill-rave-by-myself" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-b4ry8oGyxBgFuaXf-5hfiMw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Idc I'll Rave by Myself</strong>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/i-can-make-a-call-1" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-tW8h6chnIw4bfGKY-OnJnKw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>I Can Make A Call</strong>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/rainbow-bodega" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-U4RGgfX5Ay7tVLOM-3ygPMg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>Rainbow Bodega</strong><br/>
              (feat. Meauxminy)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://soundcloud.com/anjuonline/sebii-bonerr-anju-online-remix" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-9Taw9FwAqAJ7h2ue-HyF5XA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>SEBii - BONErr</strong><br/>
                (ANJU Online! Flip)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://soundcloud.com/anjuonline/them-drugs-come-in-handy-1" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-a5DaYyGawg6ZVveE-tmzI7g-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>21 Savage - X</strong><br/>
                (ANJU Online! Flip)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">DJ Set</p>
            <a href="https://www.youtube.com/watch?v=kXeKwQsEtg4" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-oRXsFL7pajM9zxnU-yDhLaA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Hellscape Radio Vol. 3</strong><br/>
                (Hosted by ANJU Online!)
              </p>
            </a>
          </div>             

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/mall-date" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-zm4J63XdnzhtdZKK-GPA3Vw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>Mall Date</strong>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/4am-anxiety-bath" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-Q19eAGloMKaNew6y-frYxow-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>4AM Anxiety Bath</strong>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/recaptcha-invalid" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-QSD3TSSOjs6fKds6-0K3YMQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>reCAPTCHA / Invalid</strong>
              </p>
            </a>
          </div>

        </div>
      </>
    );
  };
  export default AnjuAllReleases2020Static;